/* eslint-disable */
export default {
  header: 'Contact support',
  toggleTitle: '1. Turn on error tracking mode',
  toggleDescription:
    'This will help us locate your issues, but may slightly affect your app performance.',
  downloadTitle:
    '2. Download the error log when you have replicated the issue.',
  downloadButton: 'Download',
  downloadDisabledTitle:
    'Turn on error tracking mode before you can download error log.',
  sendTitle: '3. Send the log to support team',
  createSupportTicket: 'Create a support ticket',
  sendDescription:
    ' to get in touch with our support team. Then send the log to the support team for troubleshooting.',
  privacyNotice:
    'By downloading and sending us the log, you agree to allow RingCentral to access certain log-related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our ',
  privacyNoticeLink: 'Terms of Service',
  and: ' and ',
  privacyNoticeEnd: 'Privacy Notice.',
  needLeavePage:
    'You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files.',
  downloading: 'Downloading',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
